import { useProject } from '@/providers/project-provider';

export const Dashboard = () => {
    const { currentProjectId, projects } = useProject();

    // Find the current project to display its name
    const currentProject = projects.find((p) => p.id === currentProjectId);

    return (
        <div className="flex flex-col gap-6">
            <div>
                <h1 className="text-display-sm font-semibold text-primary md:text-display-md">
                    Dashboard
                </h1>
                {currentProject && (
                    <p className="mt-2 text-md text-tertiary">
                        Current Project: {currentProject.name}
                    </p>
                )}
                <p className="text-sm text-tertiary">
                    Total Projects: {projects.length}
                </p>
            </div>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {/* Your dashboard content filtered by currentProjectId */}
            </div>
        </div>
    );
};
